import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography, colors } from '@leapeasy/ui-kit';
import { DetailsCard } from 'elements/DetailsCard';
import {
  CLAIM_PAYEE_TITLE,
  formatClaimPayeeForShare,
  getClaimPayeeDisplayName,
} from 'utils/claimPayeeDisplay';
import {
  INITIAL_CLAIM_SUBMISSION_DISCLAIMER,
  INITIAL_CLAIM_SUBMISSION_TITLE,
  formatClaimCheckAddress,
  formatClaimPaymentMethod,
} from 'utils/claimInitialSubmissionDisplay';
import { hasClaimDetailValue } from 'utils/hasClaimDetailValue';
import { maskDemoField } from 'utils/demoMask';

export const InitialClaimSubmission = ({ application, isDemo }) => {
  const payeeName = getClaimPayeeDisplayName(application.who_should_the_check_be_made_out_to);
  const payeeShareText = formatClaimPayeeForShare({
    claimName: application.claim_name,
    accountName: maskDemoField(isDemo, 'account-name', application.account_name),
    payeeName: application.who_should_the_check_be_made_out_to,
  });

  const tiles = [
    {
      title: CLAIM_PAYEE_TITLE,
      value: payeeName,
      copyText: payeeShareText,
    },
    {
      title: 'Check Address',
      value: formatClaimCheckAddress(application),
    },
    {
      title: 'Check Receipt Email',
      value: hasClaimDetailValue(application.check_receipt_email)
        ? String(application.check_receipt_email).trim()
        : null,
    },
    {
      title: 'Payment Method',
      value: formatClaimPaymentMethod(application.payment_method),
    },
    {
      title: 'Best Contact Person Name',
      value: hasClaimDetailValue(application.best_contact_person_name)
        ? String(application.best_contact_person_name).trim()
        : null,
    },
    {
      title: 'Best Contact Person Email',
      value: hasClaimDetailValue(application.best_contact_person_email)
        ? String(application.best_contact_person_email).trim()
        : null,
    },
  ].filter((tile) => hasClaimDetailValue(tile.value));

  if (tiles.length === 0) return null;

  return (
    <Box borderRadius="12px" sx={{ border: '1px solid #EAEAEA', background: 'white' }} mt={1}>
      <Box display="flex" flexDirection="column" gap="10px" padding="24px">
        <Typography variant="h4" style={{ color: colors.purple[900] }}>
          {INITIAL_CLAIM_SUBMISSION_TITLE}
        </Typography>
        <Typography variant="body2" style={{ color: colors.neutral[800], maxWidth: 720 }}>
          {INITIAL_CLAIM_SUBMISSION_DISCLAIMER}
        </Typography>

        <Box display="flex" flexDirection="column" gap="8px">
          <LowContainer>
            {tiles.map((tile) => (
              <DetailsCard
                key={tile.title}
                title={tile.title}
                value={tile.value}
                copyText={tile.copyText}
              />
            ))}
          </LowContainer>
        </Box>
      </Box>
    </Box>
  );
};

const LowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  & > div {
    width: 100%;
  }

  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
